const enableNode = document.querySelector( '#wcbt_variation_enable' );

const wcbtVariation = () => {
	enableField();
};

const enableField = () => {
	if ( ! enableNode ) {
		return;
	}

	handle( enableNode );
	enableNode.addEventListener( 'change', function( event ) {
		handle( this );
	} );
};

const handle = ( enableNode ) => {
	const fieldWrapperNodes = document.querySelectorAll( '.wcbt-field-wrapper' );

	if ( ! fieldWrapperNodes ) {
		return;
	}
	const enableFieldWrapperNode = enableNode.closest( '.wcbt-field-wrapper' );
	for ( let i = 0; i < fieldWrapperNodes.length; i++ ) {
		const fieldWrapperNode = fieldWrapperNodes[ i ];
		if ( fieldWrapperNode === enableFieldWrapperNode ) {
			continue;
		}

		if ( enableNode.checked ) {
			fieldWrapperNode.style.display = 'flex';
		} else {
			fieldWrapperNode.style.display = 'none';
		}
	}
};

export default wcbtVariation;
